export default __webpack_public_path__ + "static/userDummy2-19086a5190ca1687c9d55762ac17f8a7.jpg";